import React, { useCallback, useState } from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Col, Form, Input, message, Modal, Radio, Row } from "antd";
import { STATUS } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import { securePassOutreachAttempt } from "@/services/secure_pass";

const { TextArea } = Input;

export default function LogOutreachAttemptPopup({ visible, onClose, onLogSuccess, shipmentId }) {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [formRef] = Form.useForm();

  const onSubmit = useCallback(
    ({ isSuccess, comment }) => {
      setStatus(STATUS.LOADING);
      const hide = message.loading("Logging attempt...");
      securePassOutreachAttempt({
        shipmentId,
        comment,
        isSuccess,
      })
        .then(response => {
          console.log("response => ", response);
          setStatus(STATUS.SUCCESS);
          formRef?.resetFields();
          hide();
          message.success("Attempt Logged Successfully");
          onLogSuccess?.();
          onClose?.();
        })
        .catch(err => {
          console.log("err => ", err);
          setStatus(STATUS.ERROR);
          hide();
          message.error("Error Logging Attempt");
        });
    },
    [shipmentId],
  );

  return (
    <Modal
      title={"Log Outreach Attempt"}
      visible={visible}
      onOk={formRef.submit}
      onCancel={onClose}
      confirmLoading={status === STATUS.LOADING}
    >
      <Form layout="vertical" form={formRef} onFinish={onSubmit}>
        <Row gutter={16}>
          <Col flex={1}>
            <Form.Item
              name="isSuccess"
              label="Was the attempt successful?"
              rules={[Validator.required("Please enter attempt outcome")]}
            >
              <Radio.Group style={{ display: "flex", width: "75%" }} buttonStyle="solid">
                <Radio.Button value={true} style={{ flex: 1, textAlign: "center" }}>
                  <strong>Yes</strong>
                  <CheckCircleFilled
                    style={{
                      marginLeft: 8,
                      color: "#52c41a",
                      fontSize: 14,
                      backgroundColor: "white",
                      borderRadius: 30,
                    }}
                  />
                </Radio.Button>
                <Radio.Button value={false} style={{ flex: 1, textAlign: "center" }}>
                  <strong>No</strong>
                  <CloseCircleFilled
                    style={{
                      marginLeft: 8,
                      color: "red",
                      fontSize: 14,
                      backgroundColor: "white",
                      borderRadius: 30,
                    }}
                  />
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
            <p>Please enter relevant notes on the attempt below.</p>
            <Form.Item name="comment" label="Comments" rules={[Validator.required("Please enter a comment")]}>
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
